import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import { Tooltip } from 'ui-components/components/tooltip';
import { TooltipContent } from 'ui-components/components/tooltip/tooltip-content';
import messages from '../../../messages';
import style from './style.module.less';

const name = <FormattedMessage {...messages.alertColumnHeader} />;

const alertStatuses = {
  1: {
    getTooltipText: () => <FormattedMessage {...messages.reOrderThresholdMetTooltip} />,
  },
  2: {
    getTooltipText: () => <FormattedMessage {...messages.noAvailableStock} />,
  },
};

const AlertsWarningIcon = ({ alertStatus }) => {
  const alert = alertStatuses[alertStatus];

  return (
    <Tooltip position='bottom'>
      <TooltipContent>
        <div className={style['tooltip-text']}>{alert.getTooltipText()}</div>
      </TooltipContent>
      <div className={style['verification-icon']}>
        <div className={style['icon-wrapper']}>
          <FontAwesomeIcon className={style.icon} icon={faExclamationTriangle} />
        </div>
      </div>
    </Tooltip>
  );
};

AlertsWarningIcon.propTypes = {
  alertStatus: PropTypes.number.isRequired,
};

export default {
  name,
  getMessageDescriptor: () => messages.alertColumnHeader,
  render: (data) => {
    if (!data.alertStatus) {
      return '';
    }

    return <AlertsWarningIcon alertStatus={data.alertStatus} />;
  },
};
